/* eslint-disable multiline-ternary */
/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
import { Button, Spin, Card, Col, Divider, Input, Layout, List, message, Row, Space, Table, Tooltip, InputNumber, Select, Image, Radio, Modal } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage, IntlShape } from 'react-intl'
import MenuLayout from '../components/Layout/menuLayout'
import styled from 'styled-components'
import {
  orderDetail,
  putItemToCart,
  updateShippingAddress,
  resSelfPicking,
  cancelOrderRes,
  orderProcessingRes,
  addShipment,
  getCourierInfo,
  updateShipmentInfo,
  editShipment,
  completeShipment,
  deleteShipmentInfo,
  parcelShipmentAction,
  orderComment,
  orderRefund,
  parcelComment,
  fulfillmentSwitch,
  orderItemAfterSales,
  orderItemDiscount,
  orderDiscount,
  updateShipmentMethod
} from '../api/response'
import dayjs from 'dayjs'
import * as R from 'ramda'
import isToday from 'dayjs/plugin/isToday'
import TextArea from 'antd/lib/input/TextArea'
import { logHistory, discountHistory, paymentHistoryColumns } from '../data/tableColumns'
import CustomerShippingAddress from '../components/manageCustomer/customerAddress'
import ModalForm from '../components/common/modal-form'
import PicturesWall from '../components/common/picture_wall'
import copy from 'copy-to-clipboard'
import NotifyModal from '../components/common/notifyModal'
import {
  getCurrencyRate,
  setCartChange,
  setCartIncrease,
  setCartItems,
  setTotalPrice,
  shoppingCartData
} from '../redux/reducers/cartItems_reducer'
import { OrderDetailResTypes, OrderItemsTypes, OrderDiscountTypes, RefundTypes, OrderCommentTypes, OrderTypes, OrderItemDiscountTypes, Payment, Shipment, PickingItem, AddShipmentRequestTypes } from '../models/order/orderDetail'
import { setMenuDisplay } from '../redux/reducers/menu_reducer'
import { homePageData } from '../redux/reducers/homePage_reducer'
import { setCustomerInfo } from '../redux/reducers/customerInfo_reducer'
import { ColumnsType } from 'antd/es/table'
import { setPlaceorderSuccess } from '../redux/reducers/orders_reducer'
import { useAppDispatch, useAppSelector } from '../redux/reduxHooks'
import OrderList from '../components/order/orderList'
import OrderCommentForm from '../components/order/OrderCommentForm'
import OrderRefundForm from '../components/order/OrderRefundForm'
import OrderItemRefundForm from '../components/order/OrderItemRefundForm'
import OrderDiscountForm from '../components/order/OrderDiscountForm'
import OrderItemDiscountForm from '../components/order/OrderItemDiscountForm'
import { OrderCourierTypes } from '../models/order/orderHistory'
import ParcelCommentForm from '../components/parcel/ParcelCommentForm'
import EditShipmentForm from '../components/shipment/EditShipmentForm'
import DeleteShipmentForm from '../components/shipment/DeleteShipmentForm'
import CompleteShipmentForm from '../components/shipment/CompleteShipmentForm'
import api from '../config/api'
import ShipmentDialog from '../components/shipment'
import { ShipmentMethodTypes } from '../models/shipping/shippingMethod'
import { customerInfo } from '../utils/CustomerInfo'
import { useLocation, useParams, useNavigate } from "react-router-dom-v5-compat";
import { useQuery, useInfiniteQuery } from '@tanstack/react-query'

const { Content } = Layout
const { Option } = Select
dayjs.extend(isToday)

const StyledContent = styled(Content)`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  .ant-empty {
    display: none;
  }
`
const StyledHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  height: 65px;
  color: black;
  font-weight: 600;
  background-color: #fff;
  display:flex;
  align-items: center;
`

const CardStyle = styled(Card)`
  .ant-card-head > .ant-card-head-wrapper {
    margin-left: 10px;
    margin-righ: 10px;
  }
`
const CardRow = styled(Row)`
  margin-right: -6px;
  .ant-card ant-card-bordered ant-card-small > .ant-card-head > .ant-card-head-wrapper {
    margin-left: -10px;
  }
  height: fit-content;
  margin-bottom: 1rem;
  width: 99%;
`

const OrderHistory = () => {
  const [chooseId, setChooseId] = useState<string>('')
  const [choosePrice, setChoosePrice] = useState<number>()
  const [orderCreateTime, setOrderCreateTime] = useState<number | string>()
  const [orderItems, setOrderItems] = useState<OrderItemsTypes[]>([])
  const [pickingItems, setPickingItems] = useState<PickingItem[]>([])
  const [editAddress, setEditAddress] = useState(false)
  const [editShipmentMethod, setEditShipmentMethod] = useState(false)
  const [editShipmentId, setEditShipmentId] = useState(undefined)
  const [shipmentFullfillmentEnable, setShipmentFullfillmentEnable] = useState(false)
  //打包
  const [modalAddShipmentVisible, setModalAddShipmentVisible] = useState(false)
  const [addShipmentValue, setAddShipmentValue] = useState(undefined)
  //换单
  const [modalEditShipmentVisible, setModalEditShipmentVisible] = useState(false)
  const [editShipmentValue, setEditShipmentValue] = useState(undefined)
  //发包
  const [modalCompleteShipmentVisible, setModalCompleteShipmentVisible] = useState(false)
  const [completeShipmentValue, setCompleteShipmentValue] = useState(undefined)
  //拆包
  const [modalDeleteShipmentVisible, setModalDeleteShipmentVisible] = useState(false)
  const [deleteShipmentValue, setDeleteShipmentValue] = useState(undefined)

  //出单
  const [modalParcelShipmentCreateShow, setModalParcelShipmentCreateShow] = useState(false)
  //改单
  const [modalParcelShipmentUpdateShow, setModalParcelShipmentUpdateShow] = useState(false)
  //打单
  const [modalParcelShipmentPrintShow, setModalParcelShipmentPrintShow] = useState(false)
  //称重
  const [modalParcelShipmentWeightShow, setModalParcelShipmentWeightShow] = useState(false)
  //备注
  const [modalParcelCommentVisible, setModalParcelCommentVisible] = useState(false)
  const [parcelCommentValue, setParcelCommentValue] = useState(undefined)

  const [modalParcelShipmentCancelShow, setModalParcelShipmentCancelShow] = useState(false)
  const [parcelShipmentCreateLoading, setParcelShipmentCreateLoading] = useState(false)
  const [parcelShipmentUpdateLoading, setParcelShipmentUpdateLoading] = useState(false)
  const [parcelShipmentPrintLoading, setParcelShipmentPrintLoading] = useState(false)
  const [parcelShipmentPrintButtonLoading, setParcelShipmentPrintButtonLoading] = useState(false)
  const [parcelShipmentWeightLoading, setParcelShipmentWeightLoading] = useState(false)
  const [parcelShipmentCancelLoading, setParcelShipmentCancelLoading] = useState(false)
  const [parcelShipmentId, setParcelShipmentId] = useState('0')
  const [parcelShipmentComment, setParcelShipmentComment] = useState('')
  const [parcelShipmentItems, setParcelShipmentItems] = useState('')
  const [parcelShipmentReprint, setParcelShipmentReprint] = useState(false)
  const [parcelShipmentConsigneeName, setParcelShipmentConsigneeName] = useState('')
  const [parcelShipmentConsigneePhone, setParcelShipmentConsigneePhone] = useState('')
  const [parcelShipmentConsigneeAddress, setParcelShipmentConsigneeAddress] = useState('')
  const [parcelShipmentConsigneeID, setParcelShipmentConsigneeID] = useState('')
  const [parcelTotalWeight, setParcelTotalWeight] = useState(0)
  const [parcelShipmentPrintUrl, setParcelShipmentPrintUrl] = useState('')
  const [currentStatus, setCurrentStatus] = useState('')
  const [description, setDescription] = useState('')
  const [managerComment, setManagerComment] = useState('')
  const [dispatchOrderInfo, setDispatchOrderInfo] = useState<OrderDetailResTypes>()
  const [addressId, setAddressId] = useState(0)
  const [courierCode, setCourierCode] = useState('goex')
  const [shipmentInfo, setShipmentInfo] = useState<
    {
      productId: number
      skuId: number
      quantity: number
    }[]
  >()
  const [trackingNo, setTrackingNo] = useState<string>()
  const [productResult, setProductResult] = useState([])
  const [shipmentComment, setShipmentComment] = useState('')
  const [courierWeight, setCourierWeight] = useState<number>(0)
  const [orderNo, setOrderNo] = useState('')
  const [updateDispatch, setUpdateDispatch] = useState(false)
  const [shipmentMethodId, setShipmentMethodId] = useState(0)
  const [showGrossProfit, setShowGrossProfit] = useState(false)
  const [showSalesBonus, setShowSalesBonus] = useState(false)
  const [shipmentMethod, setShipmentMethod] = useState<ShipmentMethodTypes>()
  const pictureWallRef = useRef<PicturesWall>(null)
  const dispatch = useAppDispatch()
  const storeState = useAppSelector(homePageData)
  const shoppingCartState = useAppSelector(shoppingCartData)

  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const couriers = useQuery({ queryKey: ['couriers'], queryFn: () => getCourierInfo().then((res) => { if (res.success) return res.data; else throw new Error(res.message) }) })

  const imageUrl = (img) => {
    let url = img
    if (!!img && (img.slice(0, 7) === 'http://' || img.slice(0, 8) === 'https://'))
      url = img
    else
      url = `${api.cdn}/${img}?x-oss-process=style/640w`
    return url
  }

  const columsShipmentList: ColumnsType<Shipment> = [
    {
      title: <div style={{ color: 'orange' }}>Id</div>,
      dataIndex: 'id',
      width: '3rem',
      render: (text, _record, index) => (
        <Tooltip title={text.toString()}>
          <div>{index + 1}</div>
        </Tooltip>
      )
    },
    {
      title: <div style={{ color: 'orange' }}>Status</div>,
      dataIndex: 'status',
      align: 'center',
      width: '8rem'
    },
    {
      title: <div style={{ color: 'orange' }}>Courier</div>,
      key: 'transactionId',
      align: 'center',
      width: '8rem',
      render: (_text, record) => <div>{`${record.courierName || ''} [${record.courierCode || ''}] ${record.trackingNo || ''} ${record.courierWeight || '0.000'}kg `}</div>
    },
    {
      title: <div style={{ color: 'orange' }}>Items</div>,
      align: 'center',
      dataIndex: 'items',
      // width: '11rem',
      render: (text, _record) =>
        text.map((item) => {
          return <div key={item.id}>{`${item.barcode} ${item.shippingName} * ${item.quantity}`}</div>
        })
    },
    {
      title: <div style={{ color: 'orange' }}>Photos</div>,
      align: 'center',
      width: '8rem',
      key: 'image',
      render: (_text, record) => {
        return (
          <div style={{ display: 'flex' }}>
            {record.image ? <Image src={`${imageUrl(record.image)}`} /> : null}
            {record.image2 ? <Image src={`${imageUrl(record.image2)}`} /> : null}
          </div>
        )
      }
    },
    {
      title: <div style={{ color: 'orange' }}>Comment</div>,
      align: 'center',
      // width: '15rem',
      // ellipsis: true,
      showSorterTooltip: true,
      render: (_text, record) => <div>
        <Tooltip title={dayjs(record.createdAt).format('D/MM/YYYY h:mm A')}>
          <div>{dayjs(record.createdAt).format(dayjs(record.createdAt).isToday() ? 'HH:mm' : 'DD/MM/YYYY')}</div>
        </Tooltip>
        {`${record.comment || ''}`}
      </div>
    },
    {
      title: <div style={{ color: 'orange' }}></div>,
      key: 'Action',
      align: 'center',
      width: '9rem',
      render: (_text, record) => {
        return (
          <Col>
            <Row>
              <Button.Group size="small">
                <Button
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl('')
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(false)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentCreateShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentCreate' />
                </Button>
                <Button
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl('')
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(false)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentUpdateShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentUpdate' />
                </Button>
                <Button
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl('')
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(false)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentCancelShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentCancel' />
                </Button>
              </Button.Group>
            </Row>
            <Row>
              <Button.Group size="small">
                <Button
                  disabled={record.packStatus === 'new' ? false : true}
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl(record.pdf)
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(false)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentPrintShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentPrint' />
                </Button>
                <Button
                  disabled={record.packStatus === 'printed' ? false : true}
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl(record.pdf)
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(true)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentPrintShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentReprint' />
                </Button>
                <Button
                  type='link' size='small'
                  onClick={() => {
                    setParcelShipmentId(record.id.toString())
                    setParcelShipmentPrintUrl('')
                    setParcelShipmentComment('')
                    setParcelShipmentItems('')
                    setParcelShipmentReprint(false)
                    setParcelShipmentConsigneeName('')
                    setParcelShipmentConsigneePhone('')
                    setParcelShipmentConsigneeAddress('')
                    setParcelShipmentConsigneeID('')
                    setModalParcelShipmentWeightShow(true)
                  }}
                >
                  <FormattedMessage id='parcelShipmentWeight' />
                </Button>
              </Button.Group>
            </Row>
            <Row>
              <Button.Group size="small">
                <Button
                  type='link' size='small'
                  onClick={() => {
                    const data = {
                      id: record.id.toString(),
                      courierCode: record.courierCode,
                      courierWeight: record.courierWeight,
                      trackingNo: record.trackingNo,
                      image: record.image,
                      image2: record.image2,
                    }
                    setEditShipmentValue(data)
                    setModalEditShipmentVisible(true)
                  }}
                >
                  <FormattedMessage id='shipmentEdit' />
                </Button>
                <Button
                  type='link' size='small'
                  onClick={() => {
                    const data = {
                      id: record.id.toString(),
                    }
                    setCompleteShipmentValue(data)
                    setModalCompleteShipmentVisible(true)
                  }}
                >
                  <FormattedMessage id='shipmentComplete' />
                </Button>
                <Button
                  type='link' size='small'
                  onClick={() => {
                    const data = {
                      id: record.id.toString(),
                    }
                    setDeleteShipmentValue(data)
                    setModalDeleteShipmentVisible(true)
                  }}
                >
                  <FormattedMessage id='shipmentDelete' />
                </Button>
              </Button.Group>
            </Row>
          </Col>
        )
      }
    }
  ]

  useEffect(() => {
    dispatch(getCurrencyRate())
  }, [])

  const columnsPickingItems: ColumnsType<PickingItem> = [
    {
      width: '3rem',
      title: <div style={{ color: 'orange' }}>#</div>,
      showSorterTooltip: true,
      dataIndex: 'id',
      render: (_text, record, index) => (<div>{index + 1}</div>)
    },
    {
      title: <div style={{ color: 'orange' }}>Description</div>,
      ellipsis: true,
      showSorterTooltip: true,
      dataIndex: 'barcode',
      render: (_text, record) => <Col>
        <Row>[{record.locationName || record.locationId}]
          {record.gtin ? " " + record.gtin : ''} {record.courierWeight.toFixed(3)}kg {record.shippingWeight === 0 ? '包邮' : ''} ${record.finalPrice.toFixed(2)} </Row>
        <Row>{record.name || 'No Name'}</Row>
      </Col>
    },
    {
      title: <div style={{ color: 'orange' }}>总仓</div>,
      width: '4rem',
      align: 'center',
      dataIndex: 'qtyVendorStock',
    },
    {
      title: <div style={{ color: 'orange' }}>库存</div>,
      width: '8rem',
      align: 'center',
      dataIndex: 'qtyStock',
      render: (_text, record) => <Row wrap={false}> {record.isSelfFulfillment ? " [门店]" : ' [代发]'}{record.shelf ? " [" + record.shelf + "]" : ''} {record.qtyStock} </Row>
    },
    {
      title: <div style={{ color: 'orange' }}>数量</div>,
      width: '5rem',
      align: 'center',
      dataIndex: 'qtyBuy'
    },
    {
      title: <div style={{ color: 'orange' }}>已发</div>,
      width: '5rem',
      align: 'center',
      dataIndex: 'qtyAllocated'
    },
    {
      title: <div style={{ color: 'orange' }}>待发</div>,
      width: '8rem',
      align: 'center',
      key: 'nonAllocated',
      render: (_value, record) => {
        return (
          <InputNumber
            size="small"
            min={0}
            max={record.qtyBuy - record.qtyAllocated}
            defaultValue={record.qtyAllocated === record.qtyBuy ? 0 : record.qtyBuy - record.qtyAllocated}
            readOnly={record.qtyAllocated === record.qtyBuy}
            onChange={(num) => {
              if (record.qtyAllocated === record.qtyBuy) return
              if (
                record.qtyBuy - record.qtyAllocated === +num &&
                shipmentInfo.find((item) => {
                  return item.productId === record.productId && item.skuId === record.skuId
                })
              ) {
                return
              }
              let newarr = shipmentInfo
              newarr = newarr.filter((element) => {
                return element.skuId !== record.skuId
              })
              setShipmentInfo([
                ...newarr,
                {
                  productId: record.productId,
                  skuId: record.skuId,
                  quantity: +num
                }
              ])
            }}
          />
        )
      }
    },
    {
      title: <div style={{ color: 'orange' }}>结果</div>,
      width: '9rem',
      align: 'center',
      key: 'result',
      render: (_value, record) => {
        const resultStr = productResult.find((item) => item.productId === record.productId)?.result || ''
        return <span style={{ color: 'red' }}>{resultStr}</span>
      }
    }
  ]

  const leftFooter = [
    'Gross Profit',
    'SubTotal',
    'Subtotal Discount',
    'Subtotal Refunded',
    'Weight',
    'Shipping Fee',
    'ShippingFee Discount',
    'Shipping Refunded'
  ]
  const rightFooter = ['Sales Bonus', 'Credit Spent', 'Points Earned', 'Points Spent', 'Surcharge', 'Total', 'Total Due', 'Total Paid']
  const leftFooterData = [
    'grossProfit',
    'subtotal',
    'subtotalDiscount',
    'subtotalRefunded',
    'shippingWeight',
    'shippingFee',
    'shippingFeeDiscount',
    'shippingRefunded'
  ]
  const rightFooterData = ['salesBonus', 'credit', 'pointsEarned', 'pointsSpent', 'surcharge', 'total', 'totalDue', 'totalPaid']

  const order = useQuery({
    queryKey: ['orderId', params.id, 'dispatch', location.pathname.includes('dispatch')], queryFn: () => orderDetail(params.id).then((res) => {
      if (res.success) {
        setChooseId(res.data.id.toString())
        setOrderItems(res.data.items)
        setPickingItems(res.data.pickingItems)
        setChoosePrice(res.data.total)
        setOrderCreateTime(res.data.createdAt)
        setDescription(res.data.description)
        setManagerComment(res.data.managerComment)
        setOrderNo(res.data.orderNo)
        if (location.pathname.includes('dispatch')) {
          console.log('dispatch order', res.data)
          const dispatchesArr = res.data.pickingItems.map((item) => {
            return {
              productId: item.productId,
              skuId: item.skuId,
              quantity: item.qtyBuy - item.qtyAllocated
            }
          })
          console.log('dispatchesArr', dispatchesArr)
          let newarr = dispatchesArr
          newarr = newarr.filter((element) => {
            return element.quantity !== 0
          })
          setShipmentInfo([...newarr])
          const info = res.data.shipments.find((item) => item.id.toString() === params.id.toString())
          if (info) {
            setTrackingNo(info.trackingNo)
            setCourierWeight(info.courierWeight)
            setCourierCode(info.courierCode)
            setShipmentComment(info.comment)
            if (info.image !== '' && info.image2 !== '') {
              pictureWallRef.current?.setFileList([info.image, info.image2])
            } else if (info.image2 !== '') {
              pictureWallRef.current?.setFileList([info.image2])
            } else if (info.image !== '') {
              pictureWallRef.current?.setFileList([info.image])
            }
          }
          setDispatchOrderInfo(res.data)
          setPickingItems(res.data.pickingItems)
          setOrderCreateTime(res.data.createdAt)
          setChoosePrice(res.data.total)
        }
        setShipmentFullfillmentEnable(location.pathname.includes('dispatch'))
        return res.data;
      } else {
        throw new Error(res.message)
      }
    })
  })

  useEffect(() => {
    dispatch(setMenuDisplay({ menu: false }))
  }, [location])

  // const refreshOrderDetail = (orderId) => {
  //   orderDetail(orderId).then((res) => {
  //     if (res.success) {
  //       setOrderItems(res.data.items)
  //       setPickingItems(res.data.pickingItems)
  //       setChoosePrice(res.data.total)
  //       setOrderCreateTime(res.data.createdAt)
  //       setDescription(res.data.description)
  //       setManagerComment(res.data.managerComment)
  //       setOrderNo(res.data.orderNo)
  //     }
  //   })
  // }

  const refundOptions = [
    { label: '退到预存', value: 'credit' },
    { label: '原路退回', value: 'return' }
  ]
  const stockOptions = [
    { label: '全部归还自动入库', value: 'all' },
    { label: '部分归还人工入库', value: 'manual' }
  ]

  function imageGroup(image1, image2) {
    if (image1 && image2) {
      return (
        <div style={{ display: 'flex' }}>
          <Image width={100} src={`${imageUrl(image1)}`} alt='image1' />
          <Image width={100} src={`${imageUrl(image2)}`} alt='image2' />
        </div>
      )
    } else if (image2) {
      return <Image width={100} src={`${imageUrl(image2)}`} alt='image2' />
    } else if (image1) {
      return <Image width={100} src={`${imageUrl(image1)}`} alt='image2' />
    } else {
      return <div></div>
    }
  }

  const [modalAfterSaleVisible, setModalAfterSaleVisible] = useState(false)
  const [afterSaleItem, setAfterSaleItem] = useState<OrderItemsTypes>(undefined)

  const [modalOrderDiscountVisible, setModalOrderDiscountVisible] = useState(false)
  const [orderDiscountValue, setOrderDiscountValue] = useState<OrderDiscountTypes>(undefined)

  const [modalOrderRefundVisible, setModalOrderRefundVisible] = useState(false)
  const [orderRefundValue, setOrderRefundValue] = useState<RefundTypes>(undefined)

  const [modalOrderCommentVisible, setModalOrderCommentVisible] = useState(false)
  const [orderCommentValue, setOrderCommentValue] = useState<OrderCommentTypes>(undefined)

  const [modalOrderItemDiscountVisible, setModalOrderItemDiscountVisible] = useState(false)
  const [orderItemDiscountItem, setOrderItemDiscountItem] = useState<OrderItemsTypes>(undefined)

  const productColumns: ColumnsType<OrderItemsTypes> = [
    {
      title: <div style={{ color: 'orange' }}>Item</div>,
      key: 'productName',
      render: (_text, record) => {
        if (record.productTypeExtraItems?.length > 0) {
          return (
            <List
              split={false}
              size='small'
              header={
                <div>
                  [{record.priceClass}] [{record.vendorName}] [{record.locationName}]
                  {R.isEmpty(record.shelf) || R.isNil(record.shelf) ? null : (<span>[{record.shelf}]</span>)} {record.sku || ''} {record.shippingName} {record.skuName || ''} {record.weight ? record.weight.toFixed(3) + 'kg' : ''} {record.freeShipping ? <FormattedMessage id="freeShipment" /> : ''}
                </div>
              }
              dataSource={record.productTypeExtraItems}
              renderItem={(item) => (
                <List.Item>
                  {item.sku} {item.shippingName} {item.skuName || ''} {record.expiration || ''} * {item.selectionQty}
                </List.Item>
              )}
            />
          )
        } else {
          return (
            <Row>
              <Col>
                {record.skuImage ? <Image width={50} src={`${imageUrl(record.skuImage)}`} /> :
                  (record.productImage ? <Image width={50} src={`${imageUrl(record.productImage)}`} /> : null)}
              </Col>
              <Col>
                <Row>
                  [{record.priceClass}] [{record.vendorName}] [{record.locationName}]
                  {R.isEmpty(record.shelf) || R.isNil(record.shelf) ? null : (<span>[{record.shelf}]</span>)} {record.sku || ''} {record.expiration || ''} {record.freeShipping ? <FormattedMessage id="freeShipment" /> : record.weight.toFixed(3) + 'kg'}
                </Row>
                <Row>
                  {record.shippingName} {record.skuName || ''}
                  {record.lastSoldAt && <Tooltip title={dayjs(record.lastSoldAt).format('DD/MM/YYYY HH:mm')} autoAdjustOverflow>
                    <div style={{ color: dayjs(record.lastSoldAt).isBefore(dayjs().subtract(30, 'day')) ? 'red' : 'green' }}>{dayjs(record.lastSoldAt).format(dayjs(record.lastSoldAt).isToday() ? 'HH:mm' : 'DD/MM/YYYY')}</div>
                  </Tooltip>}
                </Row>
              </Col>
            </Row>
          )
        }
      }
    },
    //disable buyanz
    // {
    //   title: <div style={{ color: 'orange' }}><FormattedMessage id='fulfill' /></div>,
    //   dataIndex: 'isSelfFulfillment',
    //   align: 'center',
    //   render: (_text, record) => {
    //     return (
    //       <Button type='link' size='small' onClick={() => {
    //         fulfillmentSwitch(record.orderId, record.id).then((res) => {
    //           if (res.success) {
    //             message.error(res.message)
    //           } else {
    //             message.error(res.message)
    //           }
    //         })
    //       }}>{record.isSelfFulfillment ? <FormattedMessage id='fulfill' /> : <FormattedMessage id='dropshipping' />}</Button>
    //     )
    //   }
    // },
    {
      title: <div style={{ color: 'orange' }}><FormattedMessage id='price' /></div>,
      dataIndex: 'finalPrice',
      align: 'center',
      render: (_text, record) => {
        return (
          <Col>
            <Row justify="center">${record.finalPrice.toFixed(2)}{record.finalPriceType != 'origin'}</Row>
            {record.price != 0 && record.price > record.finalPrice && <Row justify="center"><span style={{ textDecoration: 'line-through', color: 'gray', marginLeft: '5px' }}>${record.price.toFixed(2)}</span></Row>}
          </Col>
        )
      }
    },
    {
      title: <div style={{ color: 'orange' }}><FormattedMessage id='discount' /></div>,
      dataIndex: 'discount',
      align: 'center',
      render: (_text, record) => {
        return (
          <Row justify="center">
            {(record.discountPercent > 0 || record.discountDollar > 0) && <Button type='link' size='small' onClick={() => {
              setOrderItemDiscountItem(record)
              setModalOrderItemDiscountVisible(true)
            }}><Col>
                {record.discountPercent > 0 && <Row justify="center">{record.discountPercent}%</Row>}
                {record.discountDollar > 0 && <Row justify="center">${record.discountDollar.toFixed(2)}</Row>}
              </Col></Button>}
          </Row>

        )
      }
    },
    {
      title: <div style={{ color: 'orange' }}><FormattedMessage id='subtotal' /></div>,
      dataIndex: 'rowTotal',
      align: 'center',
      render: (text, record) => {
        return <Col>
          <Row justify="center">qty: {record.qtyOrdered}{record.qtyRefunded > 0 && <>-{record.qtyRefunded}</>}</Row>
          <Row justify="center">${record.rowTotal.toFixed(2)}</Row>
        </Col>
      }
    },
    {
      title: <div style={{ color: 'orange' }}><FormattedMessage id='aftersales' /></div>,
      dataIndex: 'lastSoldAt',
      align: 'center',
      render: (text, record) => {
        return (<Col>
          <Row justify="center">
            <Button type='link' size='small' disabled={record.qtyOrdered - record.qtyRefunded <= 0} onClick={() => {
              setAfterSaleItem(record)
              setModalAfterSaleVisible(true)
            }}><FormattedMessage id='aftersales' /></Button>
          </Row>
          {/* disable buyanz */}
          {/* <Row justify="center">
            <Button type='link' size='small' onClick={() => {
              setOrderItemDiscountItem(record)
              setModalOrderItemDiscountVisible(true)
            }}><FormattedMessage id='discount' /></Button>
          </Row> */}
        </Col>)
      }
    }
  ]

  return (
    order ? (
      <Row wrap={false}>
        <MenuLayout />
        <Col span={7}>
          <OrderList />
        </Col>
        {order.isSuccess ? (
          <Col span={17}>
            <Layout style={{ height: '100vh', position: 'absolute', width: '100%' }}>
              <StyledHeader>
                <Row style={{ width: '100%', alignItems: 'center' }}>
                  <Col span={12} style={{ paddingLeft: '10px' }}>
                    ID# {params.id}
                    <Button
                      type='link'
                      onClick={() => {
                        if (copy(params.id)) {
                          message.success('copy success')
                        } else {
                          message.warning('failed to copy')
                        }
                      }}
                    >
                      复制
                    </Button>
                  </Col>
                  <Col span={6}>
                    <Row style={{ fontSize: '1rem', fontWeight: 500 }}>
                      Status: {order.data.status}
                    </Row>
                    <Row>
                      <Col style={{ fontSize: '0.8rem', fontWeight: 300 }}>{orderCreateTime === '' ? '' : dayjs(orderCreateTime).format('DD/MM/YYYY hh:mm:ss')}</Col>
                    </Row>
                  </Col>
                  <Col span={6} style={{ textAlign: 'right', paddingRight: '10px', fontSize: '1rem' }}>NZ${choosePrice?.toFixed(2)}</Col>
                </Row>
              </StyledHeader>

              <StyledContent>
                {order.isSuccess && order.data ? (

                  !shipmentFullfillmentEnable ? (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          paddingTop: '6px',
                          paddingBottom: '6px',
                          position: 'sticky',
                          top: '1px',
                          zIndex: 1,
                          backgroundColor: 'white'
                        }}
                      >
                        <Space direction='horizontal'>
                          <Button
                            type='primary'
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            onClick={() => {
                              cancelOrderRes(order.data.id).then((res) => {
                                if (res.success) {
                                  message.success(res.message)
                                  dispatch(
                                    setCartIncrease({
                                      num: 1
                                    })
                                  )
                                } else {
                                  message.error(res.message)
                                }
                              })
                            }}
                            disabled={order.data.status !== 'pending' && order.data.status !== 'awaitpayment'}
                          >
                            <FormattedMessage id='cancelOrder' />
                          </Button>

                          <Button
                            type='primary'
                            onClick={() => {
                              const data: OrderDiscountTypes = {
                                id: order.data.id,
                                discountDollar: order.data.discount,
                                shippingDiscountDollar: order.data.shippingFeeDiscount,
                                comment: ''
                              }
                              setOrderDiscountValue(data)
                              setModalOrderDiscountVisible(true)
                            }}
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            disabled={order.data.status !== 'pending'}
                          >
                            <FormattedMessage id='orderDiscount' />
                          </Button>
                          <Button
                            type='primary'
                            onClick={() => {
                              const data = {
                                id: order.data.id,
                                price: order.data.totalDue,
                                credit: storeState.credit,
                                cart: order.data.items,
                                discountList: order.data.discounts
                              }

                              dispatch(setCartItems({ cartItems: order.data.items as any[] }))
                              dispatch(setTotalPrice({ totalPrice: order.data.totalDue }))
                              const path = {
                                pathname: `/payment/${chooseId || params.id}`,
                                query: data
                              }
                              dispatch(setPlaceorderSuccess({ success: true }))
                              dispatch(
                                setCustomerInfo({
                                  customerId: order.data.customerId,
                                  customerGroupId: order.data.customerGroupId,
                                  customerEmail: order.data.customerEmail
                                })
                              )
                              localStorage.setItem('customerIdFromOrder', order.data.customerId + '')

                              navigate(path)
                            }}
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            disabled={order.data.status !== 'pending' && order.data.status !== 'awaitpayment'}
                          >
                            <FormattedMessage id='orderPayment' />
                          </Button>
                          {order.data.status === 'paid' ? (
                            <Button
                              type='primary'
                              onClick={() => {
                                orderProcessingRes(chooseId || params.id).then((res) => {
                                  if (res.success) {
                                    dispatch(
                                      setCartIncrease({ num: 1 })
                                    )
                                    message.success(res.message)
                                  } else {
                                    message.error(res.message)
                                  }
                                })
                              }}
                              style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            >
                              <FormattedMessage id='orderLock' />
                            </Button>
                          ) : order.data.status === 'awaitpickup' ? (
                            <Button
                              type='primary'
                              onClick={() => {
                                navigate(`/order/${order.data.id}/dispatch`)
                              }}
                              style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            >
                              <FormattedMessage id='orderPickup' />
                            </Button>
                          ) : order.data.status === 'processing' ? (
                            <Button
                              type='primary'
                              style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                              onClick={() => {
                                //   const data: AddShipmentRequestTypes = {
                                //     id: chooseId || params.id,
                                //   }
                                //   setAddShipmentValue(data)
                                //   setModalAddShipmentVisible(true)
                                navigate(`/order/${order.data.id}/dispatch`)
                              }}
                            >
                              <FormattedMessage id='orderDelivery' />
                            </Button>
                          ) : null}

                          <Button
                            type='primary'
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            disabled={order.data.status !== 'paid' && order.data.status !== 'complete'}
                            onClick={() => {
                              const data: RefundTypes = {
                                id: order.data.id,
                              }
                              setOrderRefundValue(data)
                              setModalOrderRefundVisible(true)
                            }}
                          >
                            <FormattedMessage id='orderRefund' />
                          </Button>
                          <Button
                            type='primary'
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            onClick={() => {
                              const storeId = Number(localStorage.getItem('storeId'))
                              const putIntoCart = async (element) => {
                                const param = {
                                  customerId: order.data.customerId,
                                  customerGroupId: order.data.customerGroupId,
                                  storeId: +storeId,
                                  productId: element.productId,
                                  quantity: element.qtyOrdered,
                                  skuId: element.skuId
                                }
                                await putItemToCart(param)
                              }
                              Promise.all(order.data.items.map((item) => putIntoCart(item))).then((val) => {
                                dispatch(
                                  setCustomerInfo({
                                    customerId: order.data.customerId,
                                    customerGroupId: order.data.customerGroupId,
                                    customerEmail: order.data.customerEmail
                                  })
                                )
                                navigate('/')

                                return val
                              })
                            }}
                          >
                            <FormattedMessage id='reOrder' />
                          </Button>
                          <Button
                            type='primary'
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            onClick={() => {
                              const data: OrderCommentTypes = {
                                id: order.data.id,
                                visible: false,
                                notify: false
                              }
                              setOrderCommentValue(data)
                              setModalOrderCommentVisible(true)
                            }}
                          >
                            <FormattedMessage id='orderNote' />
                          </Button>
                          <Button
                            type='primary'
                            style={{ borderRadius: '5px', paddingLeft: '8px', paddingRight: '8px' }}
                            onClick={() => {
                              window.open(window.location.origin + `/print/${order.data.id}`)
                            }}
                          >
                            <FormattedMessage id='orderPrint' />
                          </Button>
                        </Space>
                      </div>

                      <CardRow>
                        <Col span={12}>
                          <CardStyle
                            size='small'
                            headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '0.5rem' }}
                            title={
                              <div style={{ color: 'orange', fontSize: '1rem' }}>
                                {order.data.shipmentMethodName}[{order.data.shippingTerm}]: {order.data.shipmentGroupName} {order.data.shipmentAreaName}
                              </div>
                            }
                            extra={
                              <div
                                style={{ cursor: 'pointer', color: 'orange' }}
                                onClick={() => {
                                  if (order.data.shippingTerm === 'pickup') {
                                    setEditShipmentMethod(true)
                                  } else if (order.data.shippingTerm != 'pickup') {
                                    setEditAddress(true)
                                  }
                                }}
                              >
                                Edit
                              </div>
                            }
                            style={{ width: '100%', margin: '6px', height: '100%' }}
                          >
                            {order.data.shippingTerm === 'pickup' ? (
                              <Col>
                                <Row style={{ fontSize: '1rem' }}>
                                  {order.data.pickupStoreName || ''}, {order.data.pickupStorePhone || ''}
                                </Row>
                                <Row style={{ fontSize: '1rem' }}>
                                  {order.data.pickupStoreAddress || ''}
                                </Row>
                              </Col>
                            ) : (
                              <Col>
                                <Row style={{ fontSize: '1rem' }}>
                                  {order.data.consigneeName || ''} {order.data.consigneePhone || ''} {order.data.consigneeID || ''}
                                </Row>
                                <Row style={{ fontSize: '1rem' }}>{order.data.consigneeAddress}</Row>
                                <Row>{imageGroup(order.data.consigneeIDPhoto, order.data.consigneeIDPhoto2)}</Row>
                              </Col>
                            )}
                          </CardStyle>
                        </Col>
                        <Col span={6}>
                          <CardStyle
                            size='small'
                            headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px' }}
                            title={<div style={{ color: 'orange', fontSize: '1rem' }}>Customer</div>}
                            style={{ width: '100%', margin: '6px', height: '100%' }}
                          >
                            <div style={{ fontSize: '1rem' }}>
                              {customerInfo(order.data, localStorage.getItem('customerGroup'))}
                            </div>
                          </CardStyle>
                        </Col>
                        <Col span={6}>
                          <CardStyle
                            size='small'
                            headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px' }}
                            title={<div style={{ color: 'orange', fontSize: '1rem' }}>Manager</div>}
                            style={{ width: '100%', margin: '6px', height: '100%' }}
                          >
                            <div style={{ fontSize: '1rem' }}>{order.data.managerName}({order.data.managerId}) {order.data.storeName}({order.data.storeId})</div>
                            {order.data.referrerId ? <div style={{ fontSize: '1rem' }}>{order.data.referrerName}({order.data.referrerId})</div> : null}
                          </CardStyle>
                        </Col>
                      </CardRow>
                      {order.data?.items.length > 0 ? (<Table
                        size='small'
                        rowKey='id'
                        columns={productColumns}
                        dataSource={order.data.items}
                        style={{ minWidth: 'fit-content', width: '100%', margin: '5px' }}
                        pagination={false}
                        footer={() => {
                          return (
                            <Row style={{ borderTop: '1px solid orange', marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                              <Col span={5}>
                                <div style={{ color: 'orange', fontSize: '1.2rem', padding: '7px 0' }}>Customer Remark</div>
                                <TextArea style={{ resize: 'none', height: '81%' }} value={description} />
                              </Col>
                              <Col span={5} offset={1}>
                                <div style={{ color: 'orange', fontSize: '1.2rem', padding: '7px 0' }}>Manager Remark</div>
                                <TextArea style={{ resize: 'none', height: '81%' }} value={managerComment} />
                              </Col>
                              <Col span={12}>
                                <Row style={{ width: '100%' }}>
                                  <Col span={12}>
                                    <List
                                      style={{ width: '100%' }}
                                      size='small'
                                      dataSource={leftFooter}
                                      renderItem={(item, index) => {
                                        if (index === 0) {
                                          return (
                                            <List.Item
                                              onMouseEnter={() => setShowGrossProfit(true)}
                                              onMouseLeave={() => setShowGrossProfit(false)}
                                            >
                                              <div>{item}</div>
                                              <div> {showGrossProfit ? `$ ${order.data[leftFooterData[index]]}` : '$ ***'}</div>
                                            </List.Item>
                                          )
                                        }
                                        else if (index === 4) {
                                          return (<List.Item>
                                            <div>{item}</div>
                                            <div>{order.data[leftFooterData[index]] ? `${order.data[leftFooterData[index]].toFixed(3)}kg` : '0.000kg'}</div>
                                          </List.Item>)
                                        }
                                        else
                                          return (<List.Item>
                                            <div>{item}</div>
                                            <div>{order.data[leftFooterData[index]] ? `$${order.data[leftFooterData[index]].toFixed(2)}` : '$0.00'}</div>
                                          </List.Item>)
                                      }}
                                    />
                                  </Col>
                                  <Col span={11} offset={1}>
                                    <List
                                      style={{ width: '100%' }}
                                      size='small'
                                      dataSource={rightFooter}
                                      renderItem={(item, index) => {
                                        if (index === 2 || index === 3) {
                                          return (
                                            <List.Item>
                                              <div>{item}</div>
                                              <div> {order.data[rightFooterData[index]]}</div>
                                            </List.Item>
                                          )
                                        } else if (index === 1 || index === 4 || index === 5 || index === 6 || index === 7) {
                                          return (
                                            <List.Item>
                                              <div>{item}</div>
                                              <div>{order.data[rightFooterData[index]] && order.data[rightFooterData[index]] > 0 ? `$${order.data[rightFooterData[index]].toFixed(2)}` : '$0.00'}</div>
                                            </List.Item>
                                          )
                                        } else {
                                          return (
                                            <List.Item
                                              onMouseEnter={() => setShowSalesBonus(true)}
                                              onMouseLeave={() => setShowSalesBonus(false)}
                                            >
                                              <div>{item}</div>
                                              <div> {showSalesBonus ? `$ ${order.data[rightFooterData[index]]}` : '$ ***'}</div>
                                            </List.Item>
                                          )
                                        }
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )
                        }}
                      />) : null}

                      {order.data?.shipments.length > 0 ? (
                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Parcels</div>}
                          style={{ minWidth: 'fit-content', margin: '6px' }}
                        >
                          <Table
                            size='small'
                            rowKey='id'
                            columns={columsShipmentList}
                            dataSource={order.data.shipments}
                            pagination={false}
                            style={{ width: '100%' }}
                          />
                        </CardStyle>
                      ) : null}
                      {order.data?.payments.length > 0 ? (
                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Payments</div>}
                          style={{ minWidth: 'fit-content', margin: '6px' }}
                        >
                          <Table
                            size='small'
                            rowKey='id'
                            columns={paymentHistoryColumns}
                            dataSource={order.data.payments}
                            pagination={false}
                            style={{ width: '100%' }}
                          />
                        </CardStyle>) : null}
                      {order.data?.discounts.length > 0 ? (
                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Discount history</div>}
                          style={{ minWidth: 'fit-content', margin: '6px' }}
                        >
                          <Table
                            size='small'
                            rowKey='id'
                            columns={discountHistory}
                            dataSource={order.data.discounts}
                            pagination={false}
                            style={{ width: '100%' }}
                          />
                        </CardStyle>
                      ) : null}
                      {order.data?.logging.length > 0 ? (
                        <CardStyle
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Logging</div>}
                          style={{ minWidth: 'fit-content', margin: '6px' }}
                        >
                          <Table
                            size='small'
                            rowKey='id'
                            columns={logHistory}
                            dataSource={order.data.logging}
                            style={{ width: '100%', background: 'white' }}
                            pagination={false}
                          />
                        </CardStyle>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '6px' }}></div>
                      <div style={{ backgroundColor: 'white' }}>
                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>{order.data.shippingTerm === 'pickup' ? '自提单' : '包裹单'}</div>}
                          style={{ width: '100%', margin: '6px' }}
                        >
                          <Row>
                            <Col span={4}>
                              {order.data.shipmentMethodName}
                            </Col>
                            <Col span={20}>
                              客户ID: {order.data.customerNo || ''}, {order.data.customerName || ''}, {order.data.customerPhone || ''}, {order.data.customerEmail || ''}
                            </Col>
                          </Row>

                          {order.data.shippingTerm != 'pickup' ? (
                            <Row>
                              收件人: {order.data.consigneeName || ''}, {order.data.consigneePhone || ''}, {order.data.consigneeID || ''}, {order.data.consigneeAddress || ''}
                            </Row>
                          ) : null}
                          <Divider style={{ marginTop: '15px', marginBottom: '15px', color: 'orange' }} />
                          {order.data.shippingTerm === 'pickup' ? null : (
                            <Row>
                              <Col span={16}>
                                <Row>
                                  <Col span={14}>
                                    公司: <Select
                                      style={{ width: '80%' }}
                                      value={courierCode}
                                      onChange={(value) => {
                                        setCourierCode(value)
                                      }}
                                    >
                                      {couriers.data.map((item, index) => {
                                        return (
                                          <Option value={item.code} key={index}>
                                            [{item.code}] {item.name}
                                          </Option>
                                        )
                                      })}
                                    </Select>
                                  </Col>
                                  <Col>
                                    重量(kg): <InputNumber min={0.01} defaultValue={courierWeight} onChange={(e) => { setCourierWeight(e) }} />
                                  </Col>
                                </Row>
                                <Row style={{ paddingTop: '15px' }}>
                                  <Col span={14}>
                                    单号: <Input
                                      style={{ width: '80%' }}
                                      value={trackingNo}
                                      onChange={(e) => {
                                        setTrackingNo(e.target.value)
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <PicturesWall number={2} ref={pictureWallRef} />
                              </Col>
                            </Row>
                          )}
                        </CardStyle>

                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Picking Items</div>}
                          style={{ width: '100%', margin: '6px' }}
                        >
                          <Table
                            rowKey='id'
                            size='small'
                            pagination={false}
                            columns={columnsPickingItems}
                            dataSource={order.data.pickingItems}
                            footer={() => {
                              return (
                                <Row>
                                  <TextArea
                                    defaultValue={shipmentComment}
                                    rows={2}
                                    allowClear
                                    style={{ flex: '3' }}
                                    onChange={(e) => {
                                      setShipmentComment(e.target.value)
                                    }}
                                  />
                                  <Button
                                    type='primary'
                                    style={{ borderRadius: '5px', flex: '1', marginLeft: '1rem' }}
                                    onClick={async () => {
                                      const pictures = JSON.parse(JSON.stringify(pictureWallRef.current?.getFileName() || '') || '')
                                      if (editShipmentId) {
                                        const data = {
                                          courierCode,
                                          courierWeight,
                                          trackingNo,
                                          comment: shipmentComment,
                                          image: pictures[0]?.name || '',
                                          image2: pictures[1]?.name || ''
                                        }
                                        const res = await updateShipmentInfo(
                                          data,
                                          params.id,
                                          editShipmentId
                                        )
                                        if (res.success) {
                                          message.success(res.message)
                                          const path = {
                                            pathname: `/order/${chooseId || params.id}`,
                                            query: currentStatus
                                          }
                                          navigate(path)
                                        }
                                      } else {
                                        if (dispatchOrderInfo.shippingTerm === 'pickup') {
                                          const selfPickParams = {
                                            comment: shipmentComment,
                                            image: pictures[0]?.name || '',
                                            image2: pictures[1]?.name || '',
                                            items: [...shipmentInfo]
                                          }
                                          resSelfPicking(selfPickParams, chooseId || params.id).then((res) => {
                                            if (res.success) {
                                              message.success(res.message)
                                              const path = {
                                                pathname: `/order/${chooseId || params.id}`,
                                                query: currentStatus
                                              }
                                              navigate(path)
                                            } else {
                                              message.error(res.message)
                                              const productResultArr = []
                                              res.data.forEach((element) => {
                                                /* const query = `${orderItems.find((item) => item.productId === element.productId).name}-${
                                                element.result
                                              }` */
                                                productResultArr.push({
                                                  productId: element.productId,
                                                  result: element.result
                                                })

                                                // message.error(query)
                                              })
                                              setProductResult(productResultArr)
                                            }
                                          })
                                        } else {
                                          const data = {
                                            courierCode,
                                            courierWeight,
                                            trackingNo,
                                            comment: shipmentComment,
                                            image: pictures[0]?.name || '',
                                            image2: pictures[1]?.name || '',
                                            items: [...shipmentInfo]
                                          }
                                          addShipment(data, chooseId || params.id).then((res) => {
                                            if (res.success) {
                                              message.success(res.message)
                                              const path = {
                                                pathname: `/order/${chooseId || params.id}`,
                                                query: currentStatus
                                              }
                                              navigate(path)
                                            } else {
                                              message.error(res.message)
                                            }
                                          })
                                        }
                                        order.refetch()
                                      }
                                    }}
                                  >
                                    {updateDispatch ? '修改' : '确认'}
                                  </Button>
                                </Row>
                              )
                            }}
                          />
                        </CardStyle>

                        <CardStyle
                          bordered={false}
                          size='small'
                          headStyle={{ borderBottom: '1px solid orange', marginLeft: '10px', marginRight: '10px' }}
                          title={<div style={{ color: 'orange', fontSize: '1rem', fontWeight: 700 }}>Parcels</div>}
                          style={{ width: '100%', margin: '6px' }}
                        >
                          <Table
                            size='small'
                            rowKey='id'
                            columns={columsShipmentList}
                            dataSource={order.data.shipments}
                            pagination={false}
                            style={{ width: '100%' }}
                          />
                        </CardStyle>
                      </div>
                    </>
                  )
                ) : null}
              </StyledContent>
            </Layout>
          </Col>) : null}


        <ModalForm
          open={editAddress}
          style={{ top: '10vh' }}
          width='80vw'
          closable
          onCancel={() => {
            setEditAddress(false)
          }}
          onOk={() => {
            const params = {
              shippingAddressId: addressId.toString(),
              comment: ''
            }
            updateShippingAddress(params, order.data.orderNo).then((res) => {
              if (res.success) {
                setAddressId(0)
                dispatch(setCartIncrease({ num: 1 }))
                message.success(res.message)
              } else {
                message.error(res.message)
              }
            })
            setEditAddress(false)
          }}
        >
          <CustomerShippingAddress
            order={order.data}
            currentAddressId={order.data?.shippingAddressId}
            addressId={(id) => { setAddressId(id) }}
          />
        </ModalForm>
        <ModalForm
          open={editShipmentMethod}
          style={{ top: '20vh' }}
          width='50vw'
          closable
          onCancel={() => {
            setEditShipmentMethod(false)
          }}
          onOk={async () => {
            const res = await updateShipmentMethod({
              id: order.data.id,
              storeId: shipmentMethod.pickup.id,
              methodId: shipmentMethodId,
              comment: ''
            })
            if (res.success) {
              message.success(res.message)
              setEditShipmentMethod(false)
            } else {
              message.error(res.message)
            }
          }}
        >
          <ShipmentDialog
            shipmentMethodId={shipmentMethodId}
            setShipmentMethodId={(data) => {
              setShipmentMethodId(data)
              console.log(data)
            }}
            addressArea={order.data?.shipmentAreaCode}
            addressGroup={order.data?.shipmentGroupId}
            shipmentMethod={(data) => setShipmentMethod(data)}
          />
        </ModalForm>
        <ModalForm
          style={{ top: '20vh' }}
          width='50vw'
          closable
          title={<FormattedMessage id='parcelShipmentCreate' />}
          open={modalParcelShipmentCreateShow}
          onCancel={() => {
            setParcelShipmentId('0')
            setParcelShipmentComment('')
            setParcelShipmentPrintUrl('')
            setParcelShipmentItems('')
            setParcelShipmentReprint(false)
            setParcelShipmentConsigneeName('')
            setParcelShipmentConsigneePhone('')
            setParcelShipmentConsigneeAddress('')
            setParcelShipmentConsigneeID('')
            setModalParcelShipmentCreateShow(false)
          }}
          confirmLoading={parcelShipmentCreateLoading}
          onOk={() => {
            // if (R.isEmpty(parcelShipmentComment)) {
            //   message.error('you must input the comment ')
            //   return
            // }
            setParcelShipmentCreateLoading(true)
            const params = {
              code: 'parcel_create',
              consigneeName: parcelShipmentConsigneeName,
              consigneePhone: parcelShipmentConsigneePhone,
              consigneeID: parcelShipmentConsigneeID,
              consigneeAddress: parcelShipmentConsigneeAddress,
              parcelItems: parcelShipmentItems,
              comment: parcelShipmentComment
            }
            parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
              setParcelShipmentCreateLoading(false)
              if (!res.success) {
                message.error(res.message)
                return
              }
              setParcelShipmentId('0')
              setParcelShipmentComment('')
              setParcelShipmentPrintUrl('')
              setParcelShipmentItems('')
              setParcelShipmentReprint(false)
              setParcelShipmentConsigneeName('')
              setParcelShipmentConsigneePhone('')
              setParcelShipmentConsigneeAddress('')
              setParcelShipmentConsigneeID('')
              setModalParcelShipmentCreateShow(false)
              order.refetch()
            })

          }}
        >
          <Row>
            <Col span={6}>
              <FormattedMessage id='parcelShipmentConsigneeName' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneeName(e.target.value)
                }}
              />
            </Col>
            <Col span={8} style={{ paddingLeft: '10px' }}>
              <FormattedMessage id='parcelShipmentConsigneePhone' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneePhone(e.target.value)
                }}
              />
            </Col>
            <Col span={10} style={{ paddingLeft: '10px' }}>
              <FormattedMessage id='parcelShipmentConsigneeID' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneeID(e.target.value)
                }}
              />
            </Col>
          </Row>
          <FormattedMessage id='parcelShipmentConsigneeAddress' />
          <Input
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentConsigneeAddress(e.target.value)
            }}
          />
          <FormattedMessage id='parcelShipmentItemsTitle' />
          <TextArea
            rows={5}
            allowClear
            placeholder={`${<FormattedMessage id='parcelShipmentItemsPlaceholder' />}`}
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentItems(e.target.value)
            }}
          />
          <FormattedMessage id='parcelShipmentCreateComment' />
          <TextArea
            rows={2}
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentComment(e.target.value)
            }}
          />
        </ModalForm>
        <ModalForm
          style={{ top: '20vh' }}
          width='50vw'
          closable
          title={<FormattedMessage id='parcelShipmentUpdate' />}
          open={modalParcelShipmentUpdateShow}
          onCancel={() => {
            setParcelShipmentId('0')
            setParcelShipmentComment('')
            setParcelShipmentPrintUrl('')
            setParcelShipmentItems('')
            setParcelShipmentReprint(false)
            setParcelShipmentConsigneeName('')
            setParcelShipmentConsigneePhone('')
            setParcelShipmentConsigneeAddress('')
            setParcelShipmentConsigneeID('')
            setModalParcelShipmentUpdateShow(false)
          }}
          confirmLoading={parcelShipmentUpdateLoading}
          onOk={() => {
            // if (R.isEmpty(parcelShipmentComment)) {
            //   message.error('you must input the comment ')
            //   return
            // }
            const params = {
              code: 'parcel_update',
              consigneeName: parcelShipmentConsigneeName,
              consigneePhone: parcelShipmentConsigneePhone,
              consigneeID: parcelShipmentConsigneeID,
              consigneeAddress: parcelShipmentConsigneeAddress,
              parcelItems: parcelShipmentItems,
              comment: parcelShipmentComment
            }
            setParcelShipmentUpdateLoading(true)
            parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
              setParcelShipmentUpdateLoading(false)
              if (!res.success) {
                message.error(res.message)
                return
              }
              setParcelShipmentId('0')
              setParcelShipmentComment('')
              setParcelShipmentPrintUrl('')
              setParcelShipmentItems('')
              setParcelShipmentReprint(false)
              setParcelShipmentConsigneeName('')
              setParcelShipmentConsigneePhone('')
              setParcelShipmentConsigneeAddress('')
              setParcelShipmentConsigneeID('')
              setModalParcelShipmentUpdateShow(false)
              order.refetch()
            })

          }}
        ><Row>
            <Col span={6}>
              <FormattedMessage id='parcelShipmentConsigneeName' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneeName(e.target.value)
                }}
              />
            </Col>
            <Col span={8} style={{ paddingLeft: '10px' }}>
              <FormattedMessage id='parcelShipmentConsigneePhone' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneePhone(e.target.value)
                }}
              />
            </Col>
            <Col span={10} style={{ paddingLeft: '10px' }}>
              <FormattedMessage id='parcelShipmentConsigneeID' />
              <Input
                allowClear
                style={{ height: 'auto' }}
                onChange={(e) => {
                  setParcelShipmentConsigneeID(e.target.value)
                }}
              />
            </Col>
          </Row>
          <FormattedMessage id='parcelShipmentConsigneeAddress' />
          <Input
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentConsigneeAddress(e.target.value)
            }}
          />
          <FormattedMessage id='parcelShipmentItemsTitle' />
          <TextArea
            rows={5}
            allowClear
            placeholder={`${<FormattedMessage id='parcelShipmentItemsPlaceholder' />}`}
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentItems(e.target.value)
            }}
          />
          <FormattedMessage id='parcelShipmentUpdateComment' />
          <TextArea
            rows={2}
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentComment(e.target.value)
            }}
          />
        </ModalForm>
        <ModalForm
          style={{ top: '20vh' }}
          width='50vw'
          closable
          title={<FormattedMessage id='parcelShipmentCancel' />}
          open={modalParcelShipmentCancelShow}
          onCancel={() => {
            setParcelShipmentId('0')
            setParcelShipmentComment('')
            setParcelShipmentPrintUrl('')
            setParcelShipmentItems('')
            setParcelShipmentReprint(false)
            setParcelShipmentConsigneeName('')
            setParcelShipmentConsigneePhone('')
            setParcelShipmentConsigneeAddress('')
            setParcelShipmentConsigneeID('')
            setModalParcelShipmentCancelShow(false)
          }}
          confirmLoading={parcelShipmentCancelLoading}
          onOk={() => {
            if (R.isEmpty(parcelShipmentComment)) {
              message.error('you must input the comment ')
              return
            }
            const params = {
              code: 'parcel_cancel',
              comment: parcelShipmentComment
            }
            setParcelShipmentCancelLoading(true)
            parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
              setParcelShipmentCancelLoading(false)
              if (!res.success) {
                message.error(res.message)
                return
              }
              setParcelShipmentId('0')
              setParcelShipmentComment('')
              setParcelShipmentPrintUrl('')
              setParcelShipmentItems('')
              setParcelShipmentReprint(false)
              setParcelShipmentConsigneeName('')
              setParcelShipmentConsigneePhone('')
              setParcelShipmentConsigneeAddress('')
              setParcelShipmentConsigneeID('')
              setModalParcelShipmentCancelShow(false)
              order.refetch()
            })

          }}
        >
          <FormattedMessage id='parcelShipmentCancelComment' />
          <TextArea
            rows={3}
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentComment(e.target.value)
            }}
          />
        </ModalForm>
        <ModalForm
          style={{ top: '20vh' }}
          width='50vw'
          closable
          title={<FormattedMessage id='parcelShipmentWeight' />}
          open={modalParcelShipmentWeightShow}
          onCancel={() => {
            setParcelShipmentId('0')
            setParcelShipmentComment('')
            setParcelShipmentPrintUrl('')
            setParcelShipmentItems('')
            setParcelShipmentReprint(false)
            setParcelShipmentConsigneeName('')
            setParcelShipmentConsigneePhone('')
            setParcelShipmentConsigneeAddress('')
            setParcelShipmentConsigneeID('')
            setModalParcelShipmentWeightShow(false)
          }}
          confirmLoading={parcelShipmentWeightLoading}
          onOk={() => {
            const params = {
              code: 'parcel_weight',
              totalWeight: parcelTotalWeight
            }
            setParcelShipmentWeightLoading(true)
            parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
              setParcelShipmentWeightLoading(false)
              if (!res.success) {
                message.error(res.message)
                return
              }
              setParcelShipmentId('0')
              setParcelShipmentPrintUrl('')
              setParcelShipmentComment('')
              setModalParcelShipmentWeightShow(false)
              order.refetch()
            })

          }}
        ><FormattedMessage id='parcelShipmentWeightTitle' />
          <InputNumber min={0.01} defaultValue={parcelTotalWeight} onChange={(e) => { setParcelTotalWeight(e) }} />
        </ModalForm>
        <ModalForm
          style={{ top: '20vh' }}
          width='50vw'
          closable
          title={<FormattedMessage id='parcelShipmentPrint' />}
          open={modalParcelShipmentPrintShow}
          onCancel={() => {
            setParcelShipmentId('0')
            setParcelShipmentPrintUrl('')
            setParcelShipmentComment('')
            setParcelShipmentItems('')
            setParcelShipmentReprint(false)
            setParcelShipmentConsigneeName('')
            setParcelShipmentConsigneePhone('')
            setParcelShipmentConsigneeAddress('')
            setParcelShipmentConsigneeID('')
            setModalParcelShipmentPrintShow(false)
            setParcelShipmentPrintLoading(false)
          }}
          confirmLoading={parcelShipmentPrintLoading}
          onOk={() => {
            // if (R.isEmpty(parcelShipmentComment)) {
            //   message.error('you must input the comment ')
            //   return
            // }
            if (!parcelShipmentReprint) {
              const params = {
                code: 'parcel_print',
                reprintLabel: parcelShipmentReprint,
                comment: parcelShipmentComment
              }
              setParcelShipmentPrintLoading(true)
              parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
                setParcelShipmentPrintLoading(false)
                if (!res.success) {
                  message.error(res.message)
                  setParcelShipmentPrintLoading(false)
                  return
                }
                // window.open(`${api.cdn}${res.data}`)
                setParcelShipmentId('0')
                setParcelShipmentComment('')
                setParcelShipmentPrintUrl('')
                setParcelShipmentItems('')
                setParcelShipmentReprint(false)
                setParcelShipmentConsigneeName('')
                setParcelShipmentConsigneePhone('')
                setParcelShipmentConsigneeAddress('')
                setParcelShipmentConsigneeID('')
                setModalParcelShipmentPrintShow(false)
                order.refetch()
              })
            } else {
              setParcelShipmentId('0')
              setParcelShipmentComment('')
              setParcelShipmentPrintUrl('')
              setParcelShipmentItems('')
              setParcelShipmentReprint(false)
              setParcelShipmentConsigneeName('')
              setParcelShipmentConsigneePhone('')
              setParcelShipmentConsigneeAddress('')
              setParcelShipmentConsigneeID('')
              setModalParcelShipmentPrintShow(false)
            }
          }}
        >
          {parcelShipmentReprint ?
            <Row>
              <Col span={4}><FormattedMessage id='parcelShipmentPrintUrlTitle' />:</Col>
              <Col span={20}>
                <a target='_blank' href={`${api.cdn}${parcelShipmentPrintUrl}`}>{parcelShipmentPrintUrl || '无'}</a>
                <Button type="primary" size='small' loading={parcelShipmentPrintButtonLoading}
                  style={{ marginLeft: '20px' }}
                  onClick={() => {
                    const params = {
                      code: 'parcel_print',
                      reprintLabel: parcelShipmentReprint,
                      comment: parcelShipmentComment
                    }
                    setParcelShipmentPrintButtonLoading(true)
                    parcelShipmentAction(params, orderNo, parcelShipmentId.toString()).then((res) => {
                      setParcelShipmentPrintButtonLoading(false)
                      if (!res.success) {
                        message.error(res.message)
                        return
                      } else message.success(res.message)
                      order.refetch()
                    })
                  }} > <FormattedMessage id='parcelShipmentReprint' /> </Button>
              </Col>
            </Row>
            : null}
          <FormattedMessage id='parcelShipmentPrintComment' />
          <TextArea
            rows={2}
            allowClear
            style={{ height: 'auto' }}
            onChange={(e) => {
              setParcelShipmentComment(e.target.value)
            }}
          />
        </ModalForm>
        <OrderCommentForm title="Order Comment"
          visible={modalOrderCommentVisible}
          onSubmit={(value) => {
            const params = {
              notify: value.notify,
              visible: value.visible ? 1 : 0,
              comment: value.comment
            }
            return orderComment(orderCommentValue.id, params).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalOrderCommentVisible(false);
                setOrderCommentValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalOrderCommentVisible(false);
            setOrderCommentValue(undefined);
          }}
          formValues={orderCommentValue}
        ></OrderCommentForm>
        <OrderRefundForm title="Order Refund"
          visible={modalOrderRefundVisible}
          onSubmit={(value) => {
            return orderRefund(orderRefundValue.id, value).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalOrderRefundVisible(false);
                setOrderRefundValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalOrderRefundVisible(false);
            setOrderRefundValue(undefined);
          }}
          formValues={orderRefundValue}
        ></OrderRefundForm>
        <OrderItemRefundForm title="Item Refund"
          visible={modalAfterSaleVisible}
          onSubmit={(value) => {
            return orderItemAfterSales(afterSaleItem.orderId, afterSaleItem.id, value).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalAfterSaleVisible(false);
                setAfterSaleItem(null);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalAfterSaleVisible(false);
            setAfterSaleItem(undefined);
          }}
          formValues={afterSaleItem}
        ></OrderItemRefundForm>
        <OrderDiscountForm title="Order Discount"
          visible={modalOrderDiscountVisible}
          onSubmit={(value) => {
            console.log(value)
            return orderDiscount(orderDiscountValue.id, value).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalOrderDiscountVisible(false);
                setOrderDiscountValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalOrderDiscountVisible(false);
            setOrderDiscountValue(undefined);
          }}
          formValues={orderDiscountValue}
        ></OrderDiscountForm>
        <OrderItemDiscountForm title="Item Discount"
          visible={modalOrderItemDiscountVisible}
          onSubmit={(value) => {
            console.log(value)
            // const params = {
            //   method: "return", //exchange, 
            //   stock: 0,
            //   quantity: 0,
            //   transfer: "credit",
            //   money: 0,
            //   pointsRefund: 0,
            //   pointsReturn: 0,
            //   comment: ""
            // }
            return orderItemDiscount(orderItemDiscountItem.orderId, orderItemDiscountItem.id, value).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalOrderItemDiscountVisible(false);
                setOrderItemDiscountItem(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalOrderItemDiscountVisible(false);
            setOrderItemDiscountItem(undefined);
          }}
          formValues={orderItemDiscountItem}
        ></OrderItemDiscountForm>
        <ParcelCommentForm title="Parcel Comment"
          visible={modalParcelCommentVisible}
          onSubmit={(value) => {

            return parcelComment(chooseId || params.id, parcelCommentValue.id, value).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalParcelCommentVisible(false);
                setParcelCommentValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalParcelCommentVisible(false);
            setParcelCommentValue(undefined);
          }}
          formValues={parcelCommentValue}
        ></ParcelCommentForm>
        {/* 打包配货表 */}
        <EditShipmentForm title={<FormattedMessage id='shipmentEdit' />}
          visible={modalEditShipmentVisible}
          onSubmit={(value) => {
            return editShipment(value, chooseId || params.id, editShipmentValue.id).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalEditShipmentVisible(false);
                setEditShipmentValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalEditShipmentVisible(false);
            setEditShipmentValue(undefined);
          }}
          formValues={editShipmentValue}
        ></EditShipmentForm>
        <CompleteShipmentForm title={<FormattedMessage id='shipmentComplete' />}
          visible={modalCompleteShipmentVisible}
          onSubmit={(value) => {
            return completeShipment({ id: chooseId || params.id, code: "complete", comment: value.comment }, chooseId || params.id, deleteShipmentValue.id.toString()).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalCompleteShipmentVisible(false);
                setCompleteShipmentValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalCompleteShipmentVisible(false);
            setCompleteShipmentValue(undefined);
          }}
          formValues={completeShipmentValue}
        ></CompleteShipmentForm>
        <DeleteShipmentForm title={<FormattedMessage id='shipmentDelete' />}
          visible={modalDeleteShipmentVisible}
          onSubmit={(value) => {
            console.log(value)
            return deleteShipmentInfo({ id: chooseId || params.id, code: "delete", comment: value.comment }, chooseId || params.id, deleteShipmentValue.id.toString()).then((res) => {
              if (res.success) {
                message.success(res.message)
                setModalDeleteShipmentVisible(false);
                setDeleteShipmentValue(undefined);
                order.refetch();
              } else {
                message.error(res.message)
              }
            })
          }}
          onCancel={() => {
            setModalDeleteShipmentVisible(false);
            setDeleteShipmentValue(undefined);
          }}
          formValues={deleteShipmentValue}
        ></DeleteShipmentForm>
      </Row >
    ) : (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size='large' />
      </div>
    )
  )
}

export default OrderHistory
